import { useFeatureFlag } from 'utils/hooks/useFeatureFlag';
import { ClientDataType } from 'utils/dataTypes';
import { useTranslation } from './useTranslation';
import { BRAND_AFFINITY_FIELD, ITBLDS_PG_PREFIX } from '../constants';

// converts mapping to an appropriate display name
export const useGetFieldDisplayName = () => {
  const isPredictiveAudiencesEnabled = useFeatureFlag('PredictiveGoals', false);
  const { t } = useTranslation();
  const tLookupPrefix = 'v2.requirementBuilder.fieldName';
  const getFieldDisplayName = (field: string, dataType: ClientDataType): string => {
    switch (field) {
      case 'campaignLabelId':
        return t(`${tLookupPrefix}.campaignLabel`);
      case 'emailListId':
      case 'userListId':
        return t(`${tLookupPrefix}.userList`);
      case 'createdAt':
        return t(`${tLookupPrefix}.creationDate`, {
          eventName: t(`v2.requirementBuilder.eventName.${dataType}`),
        });
      case 'campaignId':
        return t(`${tLookupPrefix}.campaign`);
      case 'emailListIds':
      case 'userListIds':
        return t(`${tLookupPrefix}.listMembership`);
      case 'signupDate':
        return t(`${tLookupPrefix}.signupDate`);
      case 'signupSource':
        return t(`${tLookupPrefix}.signupSource`);
      case 'profileUpdatedAt':
        return t(`${tLookupPrefix}.profileUpdatedDate`);
      case 'templateId':
        return t(`${tLookupPrefix}.templateId`);
      case 'contentId':
        return t(`${tLookupPrefix}.contentId`);
      case 'recurringCampaignId':
        return t(`${tLookupPrefix}.recurringCampaign`);
      case 'phoneNumber':
        return t(`${tLookupPrefix}.phoneNumber`);
      case 'unsubscribedChannelIds':
        return t(`${tLookupPrefix}.unsubscribedChannels`);
      case 'unsubscribedMessageTypeIds':
        return t(`${tLookupPrefix}.unsubscribedMessageTypes`);
      case 'subscribedMessageTypeIds':
        return t(`${tLookupPrefix}.isEligibleToReceiveMessageTypes`);
      case 'channelId':
        return t(`${tLookupPrefix}.messageChannel`);
      case 'messageTypeId':
        return t(`${tLookupPrefix}.messageType`);
      case 'itblInternal.emailDomain':
        return t(`${tLookupPrefix}.emailDomain`);
      case 'itblInternal.phoneType':
        return t(`${tLookupPrefix}.phoneType`);
      case 'itblInternal.phoneCountry':
        return t(`${tLookupPrefix}.phoneCountry`);
      case BRAND_AFFINITY_FIELD:
        return t(`${tLookupPrefix}.brandAffinityLabel`);
      default:
        // This is for Predictive Audiences. We add the itblDS prefix because that's how the field is named on the backend which we don't show to the user. Similar to the BrandAffinity field.
        if (isPredictiveAudiencesEnabled && field.startsWith(ITBLDS_PG_PREFIX)) {
          return field.split(ITBLDS_PG_PREFIX)[1];
        }
        // end
        return field;
    }
  };
  return { getFieldDisplayName };
};
